<template>
  <div class="mk-subject-sear">
    <input type="text" class="mk-subject-input" placeholder="请在此输入问题" />
    <div class="mk-subject-btn">
      <img src="https://mks.yybip.com/group1/M00/0B/5E/CgoRC2iCPVqAcV6TAAAU2sknozM811.png" alt />
      <span>{{ childItem.propsValue.data.customField1.text }}</span>
    </div>
  </div>
</template>

<script>
import { buttonObject } from "@/modules/autoweb/config/elementObject.js";
let buttonObjectTemp = _.cloneDeep(buttonObject);
buttonObjectTemp.text = "AI知识库";
export default {
  name: "MkSearchPhone",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "按钮",
          type: "button"
        }
      ],
      data: {
        customField1: _.cloneDeep(buttonObjectTemp)
      }
    };
  }
};
</script>

<style scoped lang="scss">
.mk-subject-sear {
  height: 1.38rem;
  display: flex;
  align-items: center;
  background-color: #fff;
  position: relative;
  .mk-subject-btn {
    position: absolute;
    right: 0.49rem;
    width: 1.77rem;
    height: 0.56rem;
    display: flex;
    align-items: center;
    background: #e1e1e1;
    border-radius: 0.35rem;
    img {
      width: 0.4rem;
      height: 0.4rem;
      margin: auto;
      margin: 0 0.12rem 0 0.15rem;
    }
    span {
      font-size: 0.25rem;
      color: #515051;
      line-height: 0.39rem;
      font-style: normal;
      text-transform: none;
    }
  }

  .mk-subject-input {
    padding: 0 1.8rem 0 0.32rem;
    margin: 0 0.42rem;
    width: calc(100% - 0.84rem);
    height: 0.69rem;
    background: #ffffff;
    border-radius: 0.35rem;
    border: 1px solid #e1e1e1;
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.26rem;
    color: #717071;
    line-height: 0.39rem;
  }
}
</style>
